import { defineAsyncComponent } from "vue"
import { reloadOnChunkError } from "@/services/chunkError.helper"

const cache = {}

// The components of a lazy require.context (require.context(dir, true, /\.vue$/i, 'lazy')) by file name, as async
// components: each one is a separate chunk loaded on first render instead of being bundled into every page that
// uses the context. Built once per context, so all instances share the same (once loaded - synchronous) components.
export const asyncComponentsFromContext = (context) => {
  // keyed by the file list too: a file added while the dev server runs keeps the context id, but has to get into the map
  const keys = context.keys()
  const cacheKey = context.id + '|' + keys.join(',')
  if(!cache[cacheKey]) {
    const components = {}
    keys.forEach(key => {
      components[key.split('/').pop().split('.')[0]] = defineAsyncComponent(() => context(key)
        .then(m => m.default)
        .catch(error => {
          reloadOnChunkError(error)
          throw error
        }))
    })
    cache[cacheKey] = components
  }
  return cache[cacheKey]
}
